<template>
  <div  style="height: 100%!important;">
    <Header/>
    <h3 class="pl-4 pr-4">
      Transit #{{$route.params.id}}
    </h3>
    <div v-if="IsLoading" class="spinner-border" style="position:fixed; top:50%; left:50%" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <span v-else>
    <div class="table-wrap tableFixHeadTransitDetail pl-4 pr-4">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Item Name</th>
              <th class="text-sm-right">QTY</th>
              <th>UOM</th>
              <th class="text-center">Difference</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr style="height:35px"  v-for="(item, i) in Invoices" :key="'invoices'+i" >
              <th scope="row">{{i+1}}.</th>
              <td>{{item.ItemName}}</td>
              <td class="text-sm-right">{{item.Quantity}}</td>
              <td>{{item.UOMCode}}</td>
              <td style="width:8%"><input type="number" class="form-control text-center ml-1" v-model="item.Difference"></td>
              <td style="width:20%"><input type="text" class="form-control text-center ml-1" v-model="item.Remarks"></td>
            </tr>
          </tbody>
        </table>
    </div>
    <br>
    <div class="d-flex flex-row pt-2 justify-content-end bg-gray-50">
      <div class="col-sm-2 col-md-3">
        <p>
          Verification Code
        </p>
        <input v-model="UniqueCode" class="form-control" />
      </div>
        <div class="col-sm-2 col-md-3">
        <p>
          Arrive Date
        </p>
        <input v-model="ArriveDate" type="datetime-local" class="form-control" />
      </div>
      <div class="d-flex flex-row align-items-center ">
        <div>
          <input type="checkbox" name="terms and conditions" v-model="tac">
        </div>
        <div class="ml-2">
          I agree to the Terms and Conditions
        </div>
      </div>
      <div class="d-flex flex-grow-1 justify-content-end">
        <button :disabled="!tac || !ArriveDate || !UniqueCode" class="btn btn-primary" style="width: 300px; height: 80px;" @click="submit">Submit</button>
      </div>
    </div>
    </span>

  </div>
</template>
<style>
  .tableFixHeadTransitDetail {
    overflow: auto;
    height: 77%;
  }

  .tableFixHeadTransitDetail thead th {
    position: sticky;
    top: 0;
    z-index: 1;
  }
  th,
  td {
    white-space: nowrap;
  }
  tr:nth-child(even) {
    background-color: #f2f2f2 !important;
  }

  body {
    line-height: 0 !important;
  }

  p {
    line-height: 10px !important;
  }

  .table thead th {
    padding: 10px !important;
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }

  .table tbody td,
  .table tbody th {
    border: none;
    padding: 10px !important;
    font-size: 14px;
    vertical-align: middle;
  }

  tr {
    padding: 0 !important;
    margin: 0 !important;
  }

  .fixed-side {
    border: 1px solid #000;
    background: #eee;
    visibility: visible;
  }

  .modal-active {
    display: block;
  }

  /* The Modal (background) */
  .modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    padding-top: 10%;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
  }

  /* Modal Content */
  .modal-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 0;
    border: 1px solid #888;
    width: 80%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s
  }

  /* Add Animation */
  @-webkit-keyframes animatetop {
    from {
      top: -300px;
      opacity: 0
    }

    to {
      top: 0;
      opacity: 1
    }
  }

  @keyframes animatetop {
    from {
      top: -300px;
      opacity: 0
    }

    to {
      top: 0;
      opacity: 1
    }
  }

  /* The Close Button */
  .close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }

  .modal-header {
    background-color: whitesmoke;
    color: white;
    height: 40px;
  }

  .modal-body {
    padding: 2px 16px;
  }
</style>
<script lang="ts" src="./TransitDetail.ts"></script>